import React, { Component } from 'react';
import { translate } from 'react-i18next';
import {withRouter} from 'react-router-dom';
import ChallengeService from '../../services/ChallengeService.js';
import { connect } from 'react-redux';
import Categories  from './Categories.js';
import {initNavbarState} from 'actions/navbar.js';
import {fetchObjectives} from 'actions/objectives.js';
import {fetchCategories, toggleSubscription} from 'actions/categories.js';
import {fetchChallenges, fetchDaily} from 'actions/challenges.js';
import {getObjective} from 'reducers/objectives.js';
import {areCategoriesLoaded,getCategories, getEnabledCategories} from 'reducers/categories.js';
import {getCategoriesByObjectiveId} from 'reducers';
import {areFeaturesLoaded, getFeaturePluginSetting} from 'reducers/features.js';


class CategoriesContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {busy:false};
        this.onClickCategory = this.onClickCategory.bind(this);
        this.onAddNewGoal = this.onAddNewGoal.bind(this);
    }

    componentWillMount() {
        var t = this.props.t;
        this.props.dispatch(initNavbarState({enable:true, title:((this.props.byObjective||this.props.all) ? t('Add New Goal') : t('Customize Goals')), menuEnable:false, backButtonEnable:true, rewardsEnable:false}));
        this.props.dispatch({type:'SET_SIDEBAR_ENABLE', enable:false});
        this.loadData();
    }

    loadData() {
        this.setState({busy:true});
        this.props.loadData()
            .catch((error)=> {
                console.error('ERROR:');
                console.error(error);
            })
            .then(()=>{
                this.setState({busy:false});
            });
    }

    onClickCategory(categoryId) {
        this.props.history.push('/categories/' + categoryId);
    }


    onAddNewGoal() {
        this.props.history.push('/objectives');
    }
    

    render() {
        console.log("props",this.props)
        return <Categories categories={this.props.categories} 
                           objective={this.props.objective}
                           onClickCategory={this.onClickCategory}
                           onAddNewGoal={(this.props.byObjective||this.props.all) ? null : (this.props.userLimit === undefined || this.props.categories.length < this.props.userLimit) && this.onAddNewGoal}
                           userLimit={this.props.userLimit}
                           categoriesLimit={this.props.featuresLoaded && this.props.categoriesLoaded && this.props.userLimit !== undefined}
                           categoriesCount={this.props.categories.length}
                           busy={this.state.busy || !this.props.featuresLoaded} />;
    }

}


const mapStateToProps = (state, ownProps) => {
    var objectiveId = ownProps.match.params.id;
    var byObjective = (objectiveId!==undefined && objectiveId!='all');
    var all = (objectiveId==='all');
    var categories = byObjective ? getCategoriesByObjectiveId(state, Number(objectiveId)) : (all ? getCategories(state.categories) : getEnabledCategories(state.categories));
    var objective = byObjective ? getObjective(state.objectives, objectiveId) : null;

    var featuresLoaded = areFeaturesLoaded(state.features);
    var categoriesLoaded = areCategoriesLoaded(state.categories);
    var userLimit = getFeaturePluginSetting(state.features, 'categories', 'userLimit') || undefined
    return {categories:categories, objectiveId, byObjective, objective, all, userLimit, featuresLoaded, categoriesLoaded};
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadData: () => Promise.all([dispatch(fetchCategories()), dispatch(fetchObjectives())]),
        dispatch: dispatch
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(translate('categories')(CategoriesContainer)));



// WEBPACK FOOTER //
// ./src/modules/categories/CategoriesContainer.js